export default "__VITE_ASSET__1266d92c__"